export function createIndexLookupMap<T extends string>(lookupMap: Record<T, unknown>): Record<T, number> {
    return Object.keys(lookupMap).reduce(
        (accum, key, index) => ({
            ...accum,
            [key]: index,
        }),
        {}
    ) as Record<T, number>;
}
